import { Icon, IconButton, Tooltip } from "@mui/material";
import { useArquivar, useDesarquivar } from "../../api/ESocialJTServiceApi";
import { useLoading } from "../loading/LoadingProvider";
import useFeedback from "../feedback/useFeedback";

function ArquivarButton({ ocorrencia }) {
  const { mutateAsync: arquivar } = useArquivar();
  const { mutateAsync: desarquivar } = useDesarquivar();
  const setLoading = useLoading();
  const { showError } = useFeedback();

  return (
    <Tooltip title={ocorrencia.arquivado ? "Desarquivar" : "Arquivar"}>
      <IconButton
        edge="end"
        aria-label={
          ocorrencia.arquivado
            ? "Desarquivar ocorrência"
            : "Arquivar ocorrência"
        }
        onClick={async (e) => {
          e.preventDefault();
          setLoading(true);
          try {
            if (ocorrencia.arquivado) {
              await desarquivar(ocorrencia.id);
            } else {
              await arquivar(ocorrencia.id);
            }
          } catch (error) {
            showError(error);
          } finally {
            setLoading(false);
          }
        }}
      >
        <Icon>{ocorrencia.arquivado ? "inventory" : "archive"}</Icon>
      </IconButton>
    </Tooltip>
  );
}

export default ArquivarButton;
